import {Track} from "./track";
import {artistCreditsFromJson} from "../artistList/artist";
import {API_BASE, asArray} from "../../../config/api";

function tracksFromJson(json: any): Track[] {
    if (!Array.isArray(json)) {
        return [];
    }
    return json.map(
        (t: any) =>
            new Track(
                t.id,
                t.title,
                artistCreditsFromJson(t.artists),
                t.album,
                t.length,
                t.album_id,
                t.track_number,
                t.mbid,
                t.disc_number
            )
    );
}

// getTracksForArtistID fetches every track this artist is credited on (via
// track_artist - features/collaborations included), by ID rather than
// matching artist names against the full track list client-side.
export async function getTracksForArtistID(artistId: number): Promise<Track[]> {
    try {
        const response = await fetch(`${API_BASE}/api/track?artistId=${artistId}`);
        const result = await response.json();

        if (!response.ok) {
            throw new Error(`Error fetching tracks for artist: ${result.message || response.statusText}`);
        }

        return tracksFromJson(result);
    } catch (error) {
        console.error(error);
        return [];
    }
}


export class Tracklist {
    private tracks: Track[];
    constructor() {
        this.tracks = [];
    }

    public getTracks(): Track[] {
        return this.tracks;
    }

    /**
     * Fetches the list of tracks from the server and updates the
     * internal track list.
     *
     * @returns {Promise<void>} A promise that resolves when the track list
     * has been updated.
     */
    public async getTracksFromServer(): Promise<void> {
        try {
            const response = await fetch(`${API_BASE}/api/track`);
            const result = await response.json();

            if (!response.ok) {
                throw new Error(`Error fetching track list: ${result.message || response.statusText}`);
            }

            this.tracks = tracksFromJson(result);
        } catch (error) {
            console.error(error);
        }
    }

}

export async function getTrackList(): Promise<string[]> {
    const requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow"
    };

    try {
        const response = await fetch(`${API_BASE}/api/track?pathMode=true`, requestOptions);
        const result = await response.json();
        if (!response.ok) {
            throw new Error(`Error fetching track list: ${result.message || response.statusText}`);
        }
        return asArray<string>(result);
    } catch (error) {
        console.error(error);
        return [];
    }
}